import React, { forwardRef } from 'react';

import { BoxProps, Flex, Box } from '@chakra-ui/react';

import { useProfileStore } from '../../../ModalProvider';
import { EColor } from '../../../Theme';

interface IProfileButtonProps extends BoxProps {
  isInverted: boolean;
  enableNewNav?: boolean;
}

export const ProfileButton = forwardRef<HTMLDivElement, IProfileButtonProps>(
  ({ isInverted, enableNewNav, ...props }, ref) => {
    const { profile } = useProfileStore();
    const initials =
      `${profile?.firstName?.[0] ?? ''}${profile?.lastName?.[0] ?? ''}`
        .trim()
        .toUpperCase() || 'FC';

    return (
      <Box
        ref={ref}
        {...props}
        aria-controls="member-navigation"
        cursor="pointer"
        data-testid="nav-profile-button"
        position="relative"
      >
        <Flex alignItems="center" position="relative">
          <Flex
            alignItems="center"
            backgroundColor={EColor.Blue75}
            borderColor={EColor.Transparent}
            borderRadius="50%"
            borderWidth="0"
            boxSize="40px"
            color={EColor.White}
            fontFamily="ABC Diatype"
            fontSize="14px"
            fontWeight="700"
            justifyContent="center"
            lineHeight="16px"
          >
            <Box>{initials}</Box>
          </Flex>
        </Flex>
      </Box>
    );
  }
);
